import { IconButton, TableCell, TableRow, TextField } from "@material-ui/core";
import React, { useState } from "react";
import PopoverColorPicker from "../../Shared/PopoverColorPicker";
import ConfirmationDialogActions from "../../Shared/ConfirmationDialogActions";
import DeleteIcon from "@material-ui/icons/Delete";
const ProductCategoriesTableRow = ({
  productCategory,
  handleUpdateLocalProductCategory,
  handleConfirmCategoryDeletion,
  index,
}) => {
  const [openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog] =
    useState(false);

  return (
    <>
      {openDeleteConfirmationDialog && (
        <ConfirmationDialogActions
          title={"Are you sure?"}
          open={openDeleteConfirmationDialog}
          contentText={`This action will permanently remove the category from the system. Products linked to this will loose their category.`}
          button1Action={() => setOpenDeleteConfirmationDialog(false)}
          button1Text={"Cancel"}
          button2Text={"Confirm"}
          button2Action={() =>
            handleConfirmCategoryDeletion(productCategory?.id)
          }
        />
      )}
      <TableRow
        className={` ${
          index % 2 === 0 ? "products-table-even-row" : "products-table-odd-row"
        } `}
      >
        <TableCell
          className={`products-table-cell ${
            index % 2 === 0
              ? "products-table-even-cell"
              : "products-table-odd-cell"
          }`}
        >
          <TextField
            size="small"
            value={productCategory.name}
            fullWidth
            onChange={(e) => {
              handleUpdateLocalProductCategory(
                "name",
                e.target.value,
                productCategory?.id
              );
            }}
            InputLabelProps={{ shrink: true }}
          />
        </TableCell>

        <TableCell className="products-table-cell">
          <PopoverColorPicker
            color={productCategory.color}
            onChange={(newColor) => {
              handleUpdateLocalProductCategory(
                "color",
                newColor,
                productCategory?.id
              );
            }}
          />
        </TableCell>
        <TableCell className="products-table-cell">
          <IconButton aria-label="settings">
            <DeleteIcon
              onClick={(e) => setOpenDeleteConfirmationDialog(true)}
            />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ProductCategoriesTableRow;
